/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Field, ErrorMessage, FieldArray } from 'formik'
import {
   Grid,
   TextField,
   Box,
   Typography,
   MenuItem,
   Select,
   Button,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import { useSelector } from 'react-redux'
import API from '../../Web/Instance'

function StepThree({
   isSubmitting,
   values,
   setFieldValue,
   touched,
   errors,
   initialValues,
}) {
   // Redux State for Contract Prefilled Data (tech stack)
   const techStack = useSelector(
      (state) => state.contractState?.quotation,
   )?.find((state) => state.id === values.quotation_id)?.estimate?.techStack

   const [technologyOptions, setTechnologyOptions] = useState([])
   const [selectedFrontend, setSelectedFrontend] = useState('')
   const [selectedBackend, setSelectedBackend] = useState('')
   const [selectedDatabase, setSelectedDatabase] = useState('')
   const [selectedDevOps, setSelectedDevOps] = useState('')
   const [selectedMobile, setSelectedMobile] = useState('')
   const [selectedCMS, setSelectedCMS] = useState('')
   const [selectedTechnologies, setSelectedTechnologies] = useState([])
   const [selectedUIUX, setSelectedUIUX] = useState('')
   const [selectedSEO, setSelectedSEO] = useState('')

   console.log(selectedFrontend, "popo")
   useEffect(() => {
      // Get technology options from API - filter only active ones
      API.get(`technology-stack/list-technology`)
         .then((response) => {
            // Filter only technologies with status: true
            const activeTechnologies =
               response.data?.response?.filter(
                  (tech) => tech.status === true,
               ) || []
            setTechnologyOptions(activeTechnologies)
         })
         .catch((error) => {
            console.error('Error fetching technology options:', error)
         })
   }, [])

   // Sync selectedTechnologies with form field (expects array of technology names)
   useEffect(() => {
      if (Array.isArray(values.proposed_technology_stack)) {
         const techObjs = values.proposed_technology_stack
            ?.map((name) =>
               technologyOptions?.find((opt) => opt.technology === name),
            )
            .filter(Boolean)
         setSelectedTechnologies(techObjs)
      }
   }, [technologyOptions, values.proposed_technology_stack])

   const handleAddTechnology = (technologyId, type) => {
      const selectedTech = technologyOptions?.find(
         (item) => item.id === technologyId && item.type === type,
      )
      if (
         selectedTech &&
         !selectedTechnologies.some((tech) => tech.id === selectedTech.id)
      ) {
         const updated = [...selectedTechnologies, selectedTech]
         setSelectedTechnologies(updated)
         setFieldValue(
            'proposed_technology_stack',
            updated?.map((t) => t.technology),
         )
      }
      // Reset select value after selection
      if (type === 'Frontend') setSelectedFrontend('')
      if (type === 'Backend') setSelectedBackend('')
      if (type === 'Database') setSelectedDatabase('')
      if (type === 'DevOps') setSelectedDevOps('')
      if (type === 'Mobile') setSelectedMobile('')
      if (type === 'CMS') setSelectedCMS('')
      if (type === 'UI/UX') setSelectedUIUX('')
      if (type === 'SEO') setSelectedSEO('')
   }

   const handleRemoveTechnology = (tech) => {
      const updated = selectedTechnologies.filter((t) => t.id !== tech.id)
      setSelectedTechnologies(updated)
      setFieldValue(
         'proposed_technology_stack',
         updated?.map((t) => t.technology),
      )
   }

   const handleRemoveItem = (id, arrayHelpers) => {
      arrayHelpers.remove(id)
   }

   return (
      <>
         <div className="card stepCard">
            <Box className="card-body" sx={{ padding: '15px' }}>
               <Grid container spacing={2}>
                  <Grid item xs={12}>
                     <Box className="commonBox">
                        <Typography variant="h6" gutterBottom align="left">
                           Proposed Technology Stack{' '}
                           <span style={{ color: 'red' }}>*</span>
                           <span
                              style={{
                                 display: 'inline-block',
                                 backgroundColor: '#d32f2f',
                                 color: '#fff',
                                 fontSize: '0.85em',
                                 fontWeight: 500,
                                 borderRadius: '16px',
                                 padding: '2px 12px',
                                 marginLeft: '8px',
                                 verticalAlign: 'middle',
                              }}
                           >
                              Required
                           </span>
                        </Typography>
                        <Grid container spacing={2}>
                           {/* Frontend */}
                           <Grid item xs={12} md={4}>
                              <label htmlFor="frontend-tech">Frontend</label>
                              <Select
                                 fullWidth
                                 value={selectedFrontend}
                                 onChange={(e) =>
                                    handleAddTechnology(
                                       e.target.value,
                                       'Frontend',
                                    )
                                 }
                                 displayEmpty
                                 renderValue={(selected) => {
                                    console.log(selectedTechnologies, "popoposssss")
                                    const currSelected = selectedTechnologies
                                       .filter((t) => t.type === 'Frontend')
                                       .map((t) => t.technology)
                                       .join(', ')

                                    return !currSelected
                                       ? 'Select Frontend Technology'
                                       : currSelected;
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select Frontend Technology
                                 </MenuItem>
                                 {technologyOptions
                                    .filter((t) => t.type === 'Frontend')
                                    ?.map((option) => (
                                       <MenuItem
                                          key={option.id}
                                          value={option.id}
                                       >
                                          {option.technology}
                                       </MenuItem>
                                    ))}
                              </Select>
                           </Grid>
                           {/* Backend */}
                           <Grid item xs={12} md={4}>
                              <label htmlFor="backend-tech">Backend</label>
                              <Select
                                 fullWidth
                                 value={selectedBackend}
                                 onChange={(e) =>
                                    handleAddTechnology(
                                       e.target.value,
                                       'Backend',
                                    )
                                 }
                                 displayEmpty
                                 renderValue={(selected) => {
                                    const currSelected = selectedTechnologies
                                       .filter((t) => t.type === 'Backend')
                                       .map((t) => t.technology)
                                       .join(', ')

                                    return !currSelected
                                       ? 'Select Backend Technology'
                                       : currSelected;
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select Backend Technology
                                 </MenuItem>
                                 {technologyOptions
                                    .filter((t) => t.type === 'Backend')
                                    ?.map((option) => (
                                       <MenuItem
                                          key={option.id}
                                          value={option.id}
                                       >
                                          {option.technology}
                                       </MenuItem>
                                    ))}
                              </Select>
                           </Grid>
                           {/* Database */}
                           <Grid item xs={12} md={4}>
                              <label htmlFor="database-tech">Database</label>
                              <Select
                                 fullWidth
                                 value={selectedDatabase}
                                 onChange={(e) =>
                                    handleAddTechnology(
                                       e.target.value,
                                       'Database',
                                    )
                                 }
                                 displayEmpty
                                 renderValue={(selected) => {
                                    const currSelected = selectedTechnologies
                                       .filter((t) => t.type === 'Database')
                                       .map((t) => t.technology)
                                       .join(', ')

                                    return !currSelected
                                       ? 'Select Database Technology'
                                       : currSelected;
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select Database Technology
                                 </MenuItem>
                                 {technologyOptions
                                    .filter((t) => t.type === 'Database')
                                    ?.map((option) => (
                                       <MenuItem
                                          key={option.id}
                                          value={option.id}
                                       >
                                          {option.technology}
                                       </MenuItem>
                                    ))}
                              </Select>
                           </Grid>
                           {/* DevOps */}
                           <Grid item xs={12} md={4}>
                              <label htmlFor="devops-tech">DevOps</label>
                              <Select
                                 fullWidth
                                 value={selectedDevOps}
                                 onChange={(e) =>
                                    handleAddTechnology(
                                       e.target.value,
                                       'DevOps',
                                    )
                                 }
                                 displayEmpty
                                 renderValue={(selected) => {
                                    const currSelected = selectedTechnologies
                                       .filter((t) => t.type === 'DevOps')
                                       .map((t) => t.technology)
                                       .join(', ')

                                    return !currSelected
                                       ? 'Select DevOps Technology'
                                       : currSelected;
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select DevOps Technology
                                 </MenuItem>
                                 {technologyOptions
                                    .filter((t) => t.type === 'DevOps')
                                    ?.map((option) => (
                                       <MenuItem
                                          key={option.id}
                                          value={option.id}
                                       >
                                          {option.technology}
                                       </MenuItem>
                                    ))}
                              </Select>
                           </Grid>
                           {/* Mobile */}
                           <Grid item xs={12} md={4}>
                              <label htmlFor="mobile-tech">Mobile</label>
                              <Select
                                 fullWidth
                                 value={selectedMobile}
                                 onChange={(e) =>
                                    handleAddTechnology(
                                       e.target.value,
                                       'Mobile',
                                    )
                                 }
                                 displayEmpty
                                 renderValue={(selected) => {
                                    const currSelected = selectedTechnologies
                                       .filter((t) => t.type === 'Mobile')
                                       .map((t) => t.technology)
                                       .join(', ')

                                    return !currSelected
                                       ? 'Select Mobile Technology'
                                       : currSelected;
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select Mobile Technology
                                 </MenuItem>
                                 {technologyOptions
                                    .filter((t) => t.type === 'Mobile')
                                    ?.map((option) => (
                                       <MenuItem
                                          key={option.id}
                                          value={option.id}
                                       >
                                          {option.technology}
                                       </MenuItem>
                                    ))}
                              </Select>
                           </Grid>
                           {/* CMS */}
                           <Grid item xs={12} md={4}>
                              <label htmlFor="cms-tech">CMS</label>
                              <Select
                                 fullWidth
                                 value={selectedCMS}
                                 onChange={(e) =>
                                    handleAddTechnology(e.target.value, 'CMS')
                                 }
                                 displayEmpty
                                 renderValue={(selected) => {
                                    const currSelected = selectedTechnologies
                                       .filter((t) => t.type === 'CMS')
                                       .map((t) => t.technology)
                                       .join(', ')

                                    return !currSelected
                                       ? 'Select CMS Technology'
                                       : currSelected;
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select CMS Technology
                                 </MenuItem>
                                 {technologyOptions
                                    .filter((t) => t.type === 'CMS')
                                    ?.map((option) => (
                                       <MenuItem
                                          key={option.id}
                                          value={option.id}
                                       >
                                          {option.technology}
                                       </MenuItem>
                                    ))}
                              </Select>
                           </Grid>
                           {/* UI/UX */}
                           <Grid item xs={12} md={4}>
                              <label htmlFor="uiux-tech">UI/UX</label>
                              <Select
                                 fullWidth
                                 value={selectedUIUX}
                                 onChange={(e) =>
                                    handleAddTechnology(e.target.value, 'UI/UX')
                                 }
                                 displayEmpty
                                 renderValue={(selected) => {
                                    const currSelected = selectedTechnologies
                                       .filter((t) => t.type === 'UI/UX')
                                       .map((t) => t.technology)
                                       .join(', ')

                                    return !currSelected
                                       ? 'Select UI/UX Technology'
                                       : currSelected;
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select UI/UX Technology
                                 </MenuItem>
                                 {technologyOptions
                                    .filter((t) => t.type === 'UI/UX')
                                    ?.map((option) => (
                                       <MenuItem
                                          key={option.id}
                                          value={option.id}
                                       >
                                          {option.technology}
                                       </MenuItem>
                                    ))}
                              </Select>
                           </Grid>
                           {/* SEO */}
                           <Grid item xs={12} md={4}>
                              <label htmlFor="seo-tech">SEO</label>
                              <Select
                                 fullWidth
                                 value={selectedSEO}
                                 onChange={(e) =>
                                    handleAddTechnology(e.target.value, 'SEO')
                                 }
                                 displayEmpty
                                 renderValue={(selected) => {
                                    const currSelected = selectedTechnologies
                                       .filter((t) => t.type === 'SEO')
                                       .map((t) => t.technology)
                                       .join(', ')

                                    return !currSelected
                                       ? 'Select SEO Technology'
                                       : currSelected;
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select SEO Technology
                                 </MenuItem>
                                 {technologyOptions
                                    .filter((t) => t.type === 'SEO')
                                    ?.map((option) => (
                                       <MenuItem
                                          key={option.id}
                                          value={option.id}
                                       >
                                          {option.technology}
                                       </MenuItem>
                                    ))}
                              </Select>
                           </Grid>
                           {/* Selected Technologies */}
                           {/* <Grid item xs={12}>
                              <Typography variant="subtitle1">
                                 Selected Technologies:
                              </Typography>
                              <Box>
                                 {selectedTechnologies?.map((tech) => (
                                    <Box
                                       key={tech.id}
                                       sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          mb: 1,
                                       }}
                                    >
                                       <Typography variant="body2">
                                          {tech.technology}{' '}
                                          <span
                                             style={{
                                                color: '#888',
                                                fontSize: '0.9em',
                                             }}
                                          >
                                             ({tech.type})
                                          </span>
                                       </Typography>
                                       &nbsp;
                                       <Button
                                          onClick={() =>
                                             handleRemoveTechnology(tech)
                                          }
                                          size="small"
                                          startIcon={<DeleteIcon />}
                                          variant="outlined"
                                          color="error"
                                          sx={{ ml: 1 }}
                                       >
                                          Remove
                                       </Button>
                                    </Box>
                                 ))}
                              </Box>
                              <ErrorMessage
                                 name="proposed_technology_stack"
                                 component="div"
                                 style={{ color: 'red' }}
                              />
                           </Grid> */}
                        </Grid>
                     </Box>
                  </Grid>

                  {/* Team Structure Section (remains unchanged) */}
                  <Grid item xs={12}>
                     <Box className="commonBox">
                        <Typography variant="h6" gutterBottom align="left">
                           Team Structure
                           <span
                              style={{
                                 display: 'inline-block',
                                 backgroundColor: '#4caf50',
                                 color: '#fff',
                                 fontSize: '0.70em',
                                 fontWeight: 500,
                                 borderRadius: '16px',
                                 padding: '2px 12px',
                                 marginLeft: '8px',
                                 verticalAlign: 'middle',
                              }}
                           >
                              Optional
                           </span>
                        </Typography>
                        <FieldArray name="team_structure">
                           {(arrayHelpers) => (
                              <div>
                                 {values?.team_structure?.map((val, index) => (
                                    <Grid
                                       container
                                       spacing={2}
                                       key={val.id}
                                       sx={{ my: 1 }}
                                    >
                                       <Grid item xs={12}>
                                          <Grid container spacing={2}>
                                             <Grid item xs={5}>
                                                <Field
                                                   fullWidth
                                                   label="Team Name"
                                                   name={`team_structure.${index}.member`}
                                                   placeholder="Enter team member name"
                                                   value={val.member}
                                                   variant="outlined"
                                                   as={TextField}
                                                   error={
                                                      touched.team_structure?.[
                                                         index
                                                      ]?.member &&
                                                      Boolean(
                                                         errors
                                                            .team_structure?.[
                                                            index
                                                         ]?.member,
                                                      )
                                                   }
                                                   helperText={
                                                      touched.team_structure?.[
                                                         index
                                                      ]?.member &&
                                                      errors.team_structure?.[
                                                         index
                                                      ]?.member
                                                   }
                                                />
                                             </Grid>

                                             <Grid item xs={2}>
                                                <Field
                                                   fullWidth
                                                   label="Engagement Team"
                                                   name={`team_structure.${index}.engagement`}
                                                   placeholder="Enter engagement team"
                                                   variant="outlined"
                                                   type="text"
                                                   as={TextField}
                                                   error={
                                                      touched.team_structure?.[
                                                         index
                                                      ]?.engagement &&
                                                      Boolean(
                                                         errors
                                                            .team_structure?.[
                                                            index
                                                         ]?.engagement,
                                                      )
                                                   }
                                                   helperText={
                                                      touched.team_structure?.[
                                                         index
                                                      ]?.engagement &&
                                                      errors.team_structure?.[
                                                         index
                                                      ]?.engagement
                                                   }
                                                />
                                             </Grid>

                                             <Grid item xs={3}>
                                                <Field
                                                   fullWidth
                                                   label="No. of Team Members"
                                                   name={`team_structure.${index}.count`}
                                                   variant="outlined"
                                                   placeholder="Enter number of team members"
                                                   type="number"
                                                   onWheel={(e) =>
                                                      e.target.blur()
                                                   }
                                                   onFocus={(e) =>
                                                      e.target.select()
                                                   }
                                                   as={TextField}
                                                   error={
                                                      touched.team_structure?.[
                                                         index
                                                      ]?.count &&
                                                      Boolean(
                                                         errors
                                                            .team_structure?.[
                                                            index
                                                         ]?.count,
                                                      )
                                                   }
                                                   helperText={
                                                      touched.team_structure?.[
                                                         index
                                                      ]?.count &&
                                                      errors.team_structure?.[
                                                         index
                                                      ]?.count
                                                   }
                                                />
                                             </Grid>

                                             <Grid item xs={2} align="right">
                                                {index === 0 ? (
                                                   <Button
                                                      onClick={() =>
                                                         arrayHelpers.push({
                                                            //id: values.team_structure.length + 1,
                                                            member: '',
                                                            engagement: '',
                                                            count: 0,
                                                         })
                                                      }
                                                      startIcon={<AddIcon />}
                                                      variant="contained"
                                                      className="addFieldBtn"
                                                   ></Button>
                                                ) : (
                                                   <Grid item xs={12}>
                                                      <Button
                                                         onClick={() =>
                                                            handleRemoveItem(
                                                               index,
                                                               arrayHelpers,
                                                            )
                                                         }
                                                         startIcon={
                                                            <DeleteIcon />
                                                         }
                                                         variant="contained"
                                                         className="deleteFieldBtn"
                                                      ></Button>
                                                   </Grid>
                                                )}
                                             </Grid>
                                          </Grid>
                                       </Grid>
                                    </Grid>
                                 ))}
                              </div>
                           )}
                        </FieldArray>
                     </Box>
                  </Grid>
               </Grid>
            </Box>
         </div>
      </>
   )
}

export default StepThree
